import React, { useState, useEffect } from 'react';
import './IntroSequence.css';

const IntroSequence = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState('loading');
  const [showButton, setShowButton] = useState(false);

  // Pasos de la secuencia
  const steps = [
    'loading',      // Pantalla de carga (4 segundos)
    'greeting',     // "De parte de tu babosin..."
    'explanation',  // "No soy tan bueno con las manualidades..."
    'playlist',     // "Por cierto la música que escuchas..."
    'reasons',      // "Por estas razones me pareces increíble"
    'complete'      // Transición a las cards
  ];

  const messages = {
    greeting: "De parte de tu babosin... 💜",
    explanation: "No soy tan bueno con las manualidades, pero sí programando, así que he preparado este sitio para ti. Es mi manera de expresarme.",
    playlist: "Por cierto, la música que escuchas es una playlist que preparé con nuestras canciones favoritas, y unas que ya te he dedicado y cantado antes (espero te acuerdes, mente de pollito)",
    reasons: "Por estas razones me pareces increíble... 💜"
  };

  useEffect(() => {
    if (currentStep === 'loading') {
      // Mostrar loading por 4 segundos
      const timer = setTimeout(() => {
        setCurrentStep('greeting');
        setShowButton(true);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [currentStep]);

  const handleNext = () => {
    const currentIndex = steps.indexOf(currentStep);
    const nextStep = steps[currentIndex + 1];
    
    if (nextStep === 'complete') {
      // Completar la secuencia
      onComplete();
    } else {
      setCurrentStep(nextStep);
      setShowButton(true);
    }
  };

  const renderLoadingScreen = () => (
    <div className="intro-loading">
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
      <p className="loading-text">paciencia frozona...</p>
      <div className="loading-dots">
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </div>
    </div>
  );

  const renderMessageScreen = () => (
    <div className="intro-message">
      <div className="message-content">
        <p className="message-text">{messages[currentStep]}</p>
        {showButton && (
          <button 
            className="continue-button"
            onClick={handleNext}
          >
            {currentStep === 'reasons' ? ' Ver las cards ' : currentStep === 'playlist' ? 'Continuar 💜' : 'Continuar 💜'}
          </button>
        )}
      </div>
    </div>
  );

  if (currentStep === 'complete') {
    return null; // La secuencia ha terminado
  }

  return (
    <div className="intro-sequence">
      {currentStep === 'loading' ? renderLoadingScreen() : renderMessageScreen()}
    </div>
  );
};

export default IntroSequence;
